import React from 'react';

function MobileIcon(props) {
    return (
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5333 0.666667H3.46665C1.16665 0.666667 0.333313 1.5 0.333313 3.84167V14.1583C0.333313 16.5 1.16665 17.3333 3.46665 17.3333H10.525C12.8333 17.3333 13.6666 16.5 13.6666 14.1583V3.84167C13.6666 1.5 12.8333 0.666667 10.5333 0.666667ZM6.99998 15.0833C6.19998 15.0833 5.54165 14.425 5.54165 13.625C5.54165 12.825 6.19998 12.1667 6.99998 12.1667C7.79998 12.1667 8.45831 12.825 8.45831 13.625C8.45831 14.425 7.79998 15.0833 6.99998 15.0833ZM8.66665 4.20833H5.33331C4.99165 4.20833 4.70831 3.925 4.70831 3.58333C4.70831 3.24167 4.99165 2.95833 5.33331 2.95833H8.66665C9.00831 2.95833 9.29165 3.24167 9.29165 3.58333C9.29165 3.925 9.00831 4.20833 8.66665 4.20833Z" fill="#C2C6D4"/>
        </svg>
    );
}

export default MobileIcon;
